import { DEFAULT_API_HOST } from '@/config/env'

/**
 * 构建 Open API 请求 URL。
 * apiHost 为空时使用相对路径 `/open/v1/...`（Cloudflare Pages Functions 或 devServer proxy）。
 */
export function buildOpenApiUrl (relativePath, queryString = '', apiHost = DEFAULT_API_HOST) {
  const host = String(apiHost ?? DEFAULT_API_HOST).replace(/\/$/, '')
  const path = relativePath.startsWith('/') ? relativePath : `/${relativePath}`
  const qs = queryString || ''
  const openPath = `/open/v1${path}${qs}`
  return host ? `${host}${openPath}` : openPath
}
